<!-- 会员卡 -->
<template>
    <div class="page_content">
        <!-- <subComponents ref="showSelectData"></subComponents> -->
        <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增会员信息' : '编辑会员信息'" width="65%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"
                   :close-on-press-escape="true" center>
            <memberModal v-if="showStatus" ref="storeMastRef" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></memberModal>
        </el-dialog>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch"></v-search>
            </div>
        </div>
        <div style="display: flex; just-content: space-between">
            <div class="page_content_center" style="width: 100%">
                <el-table :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="storePeopleClick" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                          size="mini">
                    <!-- 主信息 -->

                    <el-table-column header-align="center" label="选择操作" width="80">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini" @change="handleRadioChange(scope.row, scope.$index)">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                     :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>

                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{
                  scope.row[tableValye.entityField]
                }}</a>
                            </span>
                            <!-- 生日 -->
                            <span v-else-if="tableValye.entityField == 'memBirth'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <el-tag v-else-if="tableValye.entityField == 'memState'" size="mini" :type="scope.row.memState == 0 ? 'danger' : 'success'">
                                {{ scope.row.memState == 0 ? "停用" : "启用" }}</el-tag>
                            <el-input clearable style="width: 90px; margin: 0 1px" @blur="blur(scope.$index, tableValye.entityField)" v-else-if="tableValye.fieldType == 'input'" type="number"
                                      v-model="scope.row[tableValye.entityField]"></el-input>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page_content_bottom">
                    <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
        </el-dialog>
        <!-- 余额流水 -->
        <el-dialog title="余额流水" v-if="moneyDia" :visible.sync="moneyDia">
            <div style="margin-bottom: 15px;">
                <el-select v-model="searchMoneyType" placeholder="请选择类型" clearable style="width: 100px;margin-right: 10px;">
                    <el-option label="全部" value=0></el-option>
                    <el-option label="消费/使用" value=1></el-option>
                    <el-option label="充值/增加" value=2></el-option>
                </el-select>
                <el-input v-model="searchMoneyName" placeholder="请输入" clearable style="width: 300px;" @input="handleMoneySearch" @clear="handleMoneySearch" @keyup.enter.native="handleMoneySearch">

                </el-input>

                <el-button style="border-radius: 0;" type="primary" @click="handleMoneySearch">查询</el-button>
            </div>
            <el-table :data="moneyList" ref="moneyList" border @selection-change="handleSelectionChange" height="450px" size="mini" v-loading="loading">
                <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                <el-table-column property="opmName" label="消费单号" show-overflow-tooltip></el-table-column>
                <el-table-column property="currAmount" label="余额" show-overflow-tooltip></el-table-column>
                <el-table-column property="digest" label="摘要" show-overflow-tooltip></el-table-column>
                <el-table-column property="preAmount" label="原始金额" show-overflow-tooltip></el-table-column>
                <el-table-column property="storeName" label="门店名称" show-overflow-tooltip></el-table-column>
                <el-table-column property="takeAmount" label="发生金额" show-overflow-tooltip></el-table-column>
                <el-table-column property="remark" label="备注" show-overflow-tooltip></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="moneyDia = false">取 消</el-button>

            </div>
        </el-dialog>
        <!-- 积分流水 -->
        <el-dialog title="积分流水" v-if="integralDia" :visible.sync="integralDia">
            <div style="margin-bottom: 15px;">
                <el-select v-model="searchIntegralType" placeholder="请选择类型" clearable style="width: 100px;margin-right: 10px;">
                    <el-option label="全部" value=0></el-option>
                    <el-option label="消费/使用" value=1></el-option>
                    <el-option label="充值/增加" value=2></el-option>
                </el-select>
                <el-input v-model="integralSearchName" placeholder="请输入" clearable style="width: 300px;" @input="handleIntegralSearch" @clear="handleIntegralSearch" @keyup.enter.native="handleIntegralSearch">

                </el-input>
                <el-button style="border-radius: 0;" type="primary" @click="handleIntegralSearch">搜索</el-button>
            </div>
            <el-table :data="integralList" ref="integralList" border @selection-change="handleSelectionChange" height="450px" size="mini" v-loading="integralLoading">
                <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                <el-table-column property="businessId" label="消费单号" show-overflow-tooltip></el-table-column>
                <el-table-column property="storeName" label="门店名称" show-overflow-tooltip></el-table-column>
                <el-table-column property="digest" label="摘要" show-overflow-tooltip></el-table-column>
                <el-table-column property="prePoint" label="原始积分" show-overflow-tooltip></el-table-column>
                <el-table-column property="takePoint" label="发生变动" show-overflow-tooltip></el-table-column>
                <el-table-column property="curPoint" label="剩余积分" show-overflow-tooltip></el-table-column>

            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="integralDia = false">取 消</el-button>

            </div>
        </el-dialog>
        <!-- 优惠券记录 -->
        <el-dialog title="优惠券记录" v-if="yhqDia" :visible.sync="yhqDia">
            <div style="margin-bottom: 15px;">
                <el-select v-model="isUsed" placeholder="请选择状态" clearable style="width: 100px;margin-right: 10px;">
                    <el-option label="未使用" :value=0></el-option>
                    <el-option label="已使用" :value=1></el-option>
                </el-select>
                <el-button style="border-radius: 0;" type="primary" @click="handleYhqSearch">搜索</el-button>
            </div>
            <el-table :data="yhqList" ref="yhqListRef" border height="450px" size="mini" v-loading="yhqLoading">
                <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                <el-table-column property="yhqName" label="优惠券名称" show-overflow-tooltip></el-table-column>
                <el-table-column property="yhqDesc" label="优惠券描述" show-overflow-tooltip></el-table-column>
                <el-table-column property="startDate" label="开始日期" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.startDate) }}
                    </template>
                </el-table-column>
                <el-table-column property="endDate" label="结束日期" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.endDate) }}
                    </template>
                </el-table-column>
                <el-table-column property="useDate" label="核销日期" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.useDate) }}
                    </template>
                </el-table-column>
                <el-table-column property="isUsed" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="getStatusType(scope.row)">
                            {{ getStatusText(scope.row) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column property="remark" label="优惠券备注" show-overflow-tooltip></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="yhqDia = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 积分兑换记录 -->
        <el-dialog title="积分兑换记录" v-if="redemptionDia" :visible.sync="redemptionDia">
            <div style="margin-bottom: 15px;">
                <el-input v-model="redemptionSearchName" placeholder="请输入赠品名称" clearable style="width: 300px;" @input="handleRedemptionSearch" @clear="handleRedemptionSearch" @keyup.enter.native="handleRedemptionSearch">
                </el-input>
                <el-button style="border-radius: 0;" type="primary" @click="handleRedemptionSearch">搜索</el-button>
            </div>
            <el-table :data="redemptionList" ref="redemptionListRef" border height="450px" size="mini" v-loading="redemptionLoading">
                <el-table-column property="mrdId" label="兑换单号" show-overflow-tooltip width="140"></el-table-column>
                <el-table-column property="bgmName" label="赠品名称" show-overflow-tooltip min-width="120"></el-table-column>
                <el-table-column property="num" label="兑换数量" show-overflow-tooltip width="100" align="center"></el-table-column>
                <el-table-column property="costPoint" label="使用积分" show-overflow-tooltip width="100" align="center"></el-table-column>
                <el-table-column property="createTime" label="兑换时间" show-overflow-tooltip width="140">
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column property="createrName" label="操作员" show-overflow-tooltip width="100"></el-table-column>
                <el-table-column property="storeName" label="门店名称" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column property="retailId" label="零售订单ID" show-overflow-tooltip width="120"></el-table-column>
                <el-table-column property="remark" label="备注" show-overflow-tooltip min-width="100"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="redemptionDia = false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 修改余额 -->
        <el-dialog title="修改余额" v-if="balanceShow" :visible.sync="balanceShow">
            <el-form size="mini" inline :model="balanceObj" label-width="100px" ref="balanceObj" :show-message="false">
                <el-form-item label="账簿" prop="abookName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <label slot="label" :style="$common.labelStyle('账簿')" v-html="$common.htmlLabel('账簿')"></label>
                    <el-input clearable v-model="balanceObj.abookName" class="form_codition" @keyup.enter.native="openSearch('293839281733',0,'abookName','abookId,abookName')">
                        <el-button @click="openSearch('293839281733',0,'abookName','abookId,abookName')" slot="append" icon="el-icon-search"></el-button></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="money" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                    <label slot="label" :style="$common.labelStyle('金额')" v-html="$common.htmlLabel('金额')"></label>
                    <el-input class="form_codition" type="number" v-model.trim="balanceObj.money" :maxlength="$store.state.inputLength" placeholder="填写金额"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" class="form_codition" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入备注" v-model="balanceObj.remark">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="balanceShow = false">取 消</el-button>
                <el-button @click="onSubmit('balanceObj')">保 存</el-button>
            </div>
        </el-dialog>
        <el-dialog :title="title" :visible.sync="UploadVisible" width="30%">
            <initDataUpload ref="initDataUpload" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
// 会员卡类型新增/编辑组件
import memberModal from "./memberModal.vue"
import { nameList, searchList } from "./memCardType.js"

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        memberModal,
    },
    data() {
        //这里存放数据
        return {
            sField: "",
            exTitle: "",
            exWidth: "",
            searchList: searchList,
            getRequestData: {
                businessId: "",
                creater: 0,
                ormId: 0,
                page: 1,
                rows: 30,
                start: "",
                end: "",
                memName: "",
                memPhone: "",
            },
            //---------------
            seTitle: "",
            DialogVisible: false,
            seId: "",
            setField: "",
            setType: "",
            seWidth: "0",
            parentSearchData: {},
            //---------------
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            multipleSelection: [],
            pageShowData: {},
            tableFlag: 0,
            selectedDataIndex: 0,
            capIds: "",
            tableHeight: 0,
            showStatus: false,
            actionData: {},
            selectedRowIndex: null,
            moneyDia: false,
            moneyList: [],
            loading: false,
            searchMoneyName: "",
            integralDia: false,
            integralList: [],
            integralLoading: false,
            integralSearchName: "",
            searchMoneyType: "0",
            searchIntegralType: "0",
            // 优惠券弹窗参数
            yhqDia: false,
            isUsed: '',
            yhqList: [],
            yhqLoading: false,
            // 积分兑换记录弹窗参数
            redemptionDia: false,
            redemptionList: [],
            redemptionLoading: false,
            redemptionSearchName: "",
            importType: '',// 导入类型
            url: '',// 导入地址
            title: "",// 弹窗标题
            requesUrl: "",
            UploadVisible: false,
            //-------------------账簿
            balanceShow: false,
            balanceObj: {
                abookId: "",
                abookName: "",
                money: "",
                remark: "",
				memId:"",
            },

        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.smName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.pspmBuycus = ""
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 获取优惠券状态文本
        getStatusText(row) {
            if (row.isUsed == 1) {
                return '已使用';
            }

            // 判断是否过期
            const currentTime = new Date().getTime();
            const endTime = new Date(row.endDate).getTime();

            if (currentTime > endTime) {
                return '已过期';
            }

            return '未使用';
        },

        // 获取优惠券状态类型（用于设置标签颜色）
        getStatusType(row) {
            if (row.isUsed == 1) {
                return 'success'; // 已使用 - 绿色
            }

            // 判断是否过期
            const currentTime = new Date().getTime();
            const endTime = new Date(row.endDate).getTime();

            if (currentTime > endTime) {
                return 'danger'; // 已过期 - 红色
            }

            return 'warning'; // 未使用 - 橙色
        },

        // 子组件触发
        drawerCancel(e) {
            console.log(e, "+++++++++")
            this.showStatus = false
            // this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            //  if (orderId) {
            //     // 设置为true 打开穿透组件首页
            //     var isPenetrate = true
            //     // 设置缓存 存入点击单号
            //     this.resetSetItem('penetrateOrderId', orderId);
            //     // 与父级跨域通信 传递isPenetrate参数
            //     window.parent.postMessage({  //向窗口发送MessageEvent消息
            //        cmd: 'returnFormJson',
            //        params: { isPenetrate } //参数
            //     }, '*');
            //  }
            this.getPageInfo()
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)

            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            )
        },
        storePeopleClick(row) {
            this.capIds = row.memId
            this.selectedRowIndex = this.returnData.list.findIndex(
                (item) => item.memId === row.memId
            )
        },

        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField, field) {
            this.setType = type
            this.seId = sId
            this.setField = sField
            this.parentSearchData[this.setType] = this.getRequestData[this.setType]
            if (this.setType == "salesName") {
                this.parentSearchData.opmSalesperson = 1
            }
            this.DialogVisible = true
        },

        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(",")
            arr.forEach((item) => {
                this.getRequestData[item] = val[item]
            })
        },
        //检索方案返回的数据
        changeInputModel(val) {
            if (val) {
                if (this.setType == "salesName") {
                    this.getRequestData.salesName = val.opmName
                    this.getRequestData.salesId = val.opmId
                }else if (this.setType=='abookName') {
					this.balanceObj.abookName = val.abookName
					this.balanceObj.abookId = val.abookId
				} else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false
        },

        handleSelectionChange(val) {
            this.multipleSelection = val
        },

        // 勾选明细
        handleSelectionChange(val) {
            console.log(val, "+++++++++")
            this.multipleSelection = val
        },

        getSeWidth(e) {
            console.log(e)
            this.seWidth = e + "%"
        },
        getWidth(e) {
            console.log(e)
            this.exWidth = e + "%"
        },
        getSearchName(e) {
            console.log(e)
            this.seTitle = e
        },

        // 获取数据列表
        async getPageInfo() {
            this.pageShowData = JSON.parse(JSON.stringify(nameList))
            let res = await this.$http.queryMembermastList(this.getRequestData)
            if (res.status == 200) {
                this.returnData.list = res.result.list
                this.returnData.total = res.result.total
                this.returnData.pageNum = res.result.pageNum
                this.returnData.pages = res.result.pages
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.capIds = this.returnData.list[0].memId

                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                }
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                })
            }
        },
        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {
                case 0:
                    this.showStatus = true
                    this.actionData = {
                        cate: 0,
                        formData: [],
                        oldData: "",
                    }
                    break
                case 1:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
                    this.showStatus = true
                    this.actionData = {
                        cate: 1,
                        formData: [],
                        oldData: this.returnData.list[this.selectedRowIndex],
                    }
                    break
                case 2:
                    this.delDataAction()
                    break
                case 4:
                    this.queryOperator()
                    this.moneyDia = true
                    break
                case 5:
                    this.queryIntegralOperator()
                    this.integralDia = true
                    break
                case 6:
                    this.queryYhqOperator()
                    this.yhqDia = true
                    break
                case 7:
                    this.queryRedemptionOperator()
                    this.redemptionDia = true
                    break
                case 8:
                    //    下载模板
                    window.location.href = `${this.$store.getters.getConfig.requestUrl}/member/downloadTemplate`
                    break
                case 9:
                    // 导入
                    this.title = '导入会员列表'
                    this.importType = 'memberImportExcel'
                    this.url = 'member/importExcel'
                    this.UploadVisible = true
                    break
                case 10:
                    this.$confirm('确定要初始化积分校验吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(() => {
                        this.$http.memberInitCheck().then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                });
                                this.getDataList();
                            } else {
                                this.$message({
                                    message: res.message,
                                    type: "error",
                                });
                            }
                        })
                    }).catch(() => {
                    });
                    break
                case 11:
                    if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                        this.$message({
                            message: "请先选中要操作的数据",
                            type: "error",
                        })
                        return false
                    }
					this.balanceObj.abookId = ''
					this.balanceObj.abookName = ''
					this.balanceObj.money = ''
					this.balanceObj.remark = ''
					this.balanceObj.memId=this.returnData.list[this.selectedRowIndex].memId
                    this.balanceShow = true
                    break
            }
        },
        onSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    const res = await this.$http.memRechargechange(this.balanceObj)
                    if (res.status == 200) {
                        this.$message({
                            message: res.message,
                            type: "success",
                        });
                        this.balanceShow = false
                        this.getDataList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: "error",
                        });
                    }
                } else {
                    this.$message.error('请完善必填项')
                    return false;
                }
            });
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.queryMembermastList(
                this.getRequestData
            )
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.returnData.pages = responseData.result.pages
                this.selectedDataIndex = 0
                if (this.returnData.list.length > 0) {
                    this.capIds = this.returnData.list[0].memId

                    this.$nextTick(() => {
                        this.selectedRowIndex = 0
                        this.multipleSelection = [this.returnData.list[0]]
                    })
                }
                this.$nextTick(() => {
                    this.tableHeight = this.$common.getTableHeight()
                    this.tableFlag++
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                })
            }
        },

        // 删除数据
        delDataAction() {
            if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                })
                return false
            }

            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    var delData = {
                        ids: [this.returnData.list[this.selectedRowIndex].memId],
                    }
                    let responseData = await this.$http.delMembermast(delData)
                    if (responseData.status == 200) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })

                        this.getDataList()
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => { })
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()

        },

        handleRadioChange(row, index) {
            this.selectedRowIndex = index
            this.capIds = row.memId
        },
        // 余额流水搜索
        handleMoneySearch() {


            this.queryOperator();

        },
        async queryOperator() {
            this.loading = true;
            let params = {
                businessId: "",
                creater: 0,
                end: "",
                memName: this.searchMoneyName || "",
                ormId: 0,
                page: 1,
                rows: 1000,
                start: "",
                memId: this.capIds,
                type: this.searchMoneyType
            };
            let responseData = await this.$http.getRecord(params);
            this.loading = false;
            if (responseData && responseData.status == 200) {
                this.moneyList = responseData.result.list
            } else {
                this.moneyList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 积分流水搜索
        handleIntegralSearch() {
            this.queryIntegralOperator();
        },
        async queryIntegralOperator() {
            this.integralLoading = true;
            let params = {
                businessId: "",
                creater: 0,
                end: "",
                memName: this.integralSearchName || "",
                ormId: 0,
                page: 1,
                rows: 1000,
                start: "",
                memId: this.capIds,
                type: this.searchIntegralType
            };
            let responseData = await this.$http.getIntegralRecord(params);
            this.integralLoading = false;
            if (responseData && responseData.status == 200) {
                this.integralList = responseData.result.list
            } else {
                this.integralList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 优惠券记录搜索
        handleYhqSearch() {
            this.queryYhqOperator();
        },
        async queryYhqOperator() {
            this.yhqLoading = true;
            let params = {
                ableUse: 0,
                businessId: "",
                end: "",
                isUsed: this.isUsed,
                memId: this.capIds,
                ormId: 0,
                page: 1,
                rows: 1000,
                start: ""
            };
            let responseData = await this.$http.getMemYhq(params);
            this.yhqLoading = false;
            if (responseData && responseData.status == 200) {
                this.yhqList = responseData.result.list
            } else {
                this.yhqList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 积分兑换记录查询
        async queryRedemptionOperator() {
            this.redemptionLoading = true;
            let params = {
                memId: this.capIds,
                page: 1,
                rows: 1000,
                start: '',
                bgmName: this.redemptionSearchName || '',
                businessId: '',
                end: '',
            };
            let responseData = await this.$http.memRedeemRedeemHis(params);
            this.redemptionLoading = false;
            if (responseData && responseData.status == 200) {
                this.redemptionList = responseData.result.list
            } else {
                this.redemptionList = [];
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 积分兑换记录搜索
        handleRedemptionSearch() {
            this.queryRedemptionOperator();
        },
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(refresh) {
            this.UploadVisible = false
            if (refresh) this.getDataList();
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
        this.getButtonList()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
            this.tableFlag++
        })
    },
    updated() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight()
        })
    }, //生命周期 - 更新之后
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.btns {
    display: flex;
    position: absolute;
    z-index: 999;
    padding-left: 10px;
    padding-top: 2px;
}

::v-deep.xunjia tr {
    height: 39px !important;
}

::v-deep.xunjia .el-button {
    font-size: 12px;
    padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
    color: #fff;
    background-color: #f56c6c;
    border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
    color: #fff;
    background-color: #f78989;
    border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
    height: 100% !important;
    position: absolute;
    top: 0;
    overflow: hidden;
    background-color: #fff;
    z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
    background-color: #fff;
}
</style>
